/* global axios */
import ApiClient from '../ApiClient';

// Private follow-up reminders. The server scopes every call to the current
// agent; nothing here can read another agent's reminders.
class TeletelRemindersAPI extends ApiClient {
  constructor() {
    super('reminders', { accountScoped: true });
  }

  baseUrl() {
    return `/teletel${super.baseUrl()}`;
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }

  forConversation(conversationId) {
    return this.list({
      conversation_display_id: conversationId,
      status: 'pending',
    });
  }

  markStatus(id, status, completionReason = null) {
    const payload = { status };
    if (completionReason !== null) {
      payload.completion_reason = completionReason;
    }
    return axios.patch(`${this.url}/${id}`, payload);
  }

  reschedule(id, remindAt) {
    return axios.patch(`${this.url}/${id}`, { remind_at: remindAt });
  }

  updateReminder(id, { remindAt, note }) {
    return axios.patch(`${this.url}/${id}`, { remind_at: remindAt, note });
  }
}

export default new TeletelRemindersAPI();
